const SEO = [
	{
		page: "home",
		description:
			"Sou um desenvolvedor iOS apaixonado pela criação de experiências digitais excepcionais. Com experiência sólida em Swift, SwiftUI e arquiteturas iOS, estou pronto para contribuir com projetos inovadores que desafiem os limites da tecnologia móvel. Busco aplicar minha expertise em desenvolvimento de aplicativos móveis e otimização de desempenho para oferecer soluções eficientes e impactantes.",
		keywords: ["Doni", "Doni de Souza", "Doni de Souza"],
	},

	{
		page: "about",
		description:
			"Sou um desenvolvedor iOS apaixonado pela criação de experiências digitais excepcionais. Com experiência sólida em Swift, SwiftUI e arquiteturas iOS, estou pronto para contribuir com projetos inovadores que desafiem os limites da tecnologia móvel. Busco aplicar minha expertise em desenvolvimento de aplicativos móveis e otimização de desempenho para oferecer soluções eficientes e impactantes.",
		keywords: ["Doni", "Doni de Souza", "Doni de Souza", "SwiftUI"],
	},

	{
		page: "articles",
		description:
			"Algumas das minhas ideias e opiniões ao longo do tempo sobre programação, dados, viajens, design e muito mais.",
		keywords: ["Doni", "Doni de Souza", "Doni de Souza"],
	},

	{
		page: "projects",
		description:
			"Ao longo dos anos, trabalhei em uma variedade de projetos e estou orgulhoso do progresso que fiz. Muitos desses projetos são de código aberto e estão disponíveis para que outras pessoas explorem e contribuam - você pode conferir no meu GitHub. Se você estiver interessado em algum dos projetos para sugerir quaisquer melhorias ou aprimoramentos. Colaborar com outras pessoas é uma ótima maneira de aprender e crescer, e estou sempre aberto a novas ideias e feedbacks.",
		keywords: ["Doni", "Doni de Souza", "Doni de Souza"],
	},

	{
		page: "contact",
		description:
			"Agradeço pelo seu interesse em entrar em contato comigo. Afinal feedbacks, perguntas e sugestões são sempre bem vindos. Se você tiver alguma dúvida ou comentário específico, por favor, sinta-se à vontade para me enviar um e-mail e responderei o mais rápido que possível. Se preferir se conectar através das redes sociais. Obrigado novamente pelo seu interesse e estou ansioso para receber sua mensagem!",
		keywords: ["Doni", "Doni de Souza", "Doni de Souza"],
	},
];

export default SEO;
